/**
 * Resource that represents an Inventory.
 *
 * @name Inventory
 * @class
 * @augments TmrResource
 */
function InventoryFactory(TmrApi, TmrResource, Zone) {
  'ngInject'
  let referencedProperties = [
    // inventory.inventoryZones property will be instantiated as a Zone resource
    { property: 'inventoryZones', resource: Zone },
    // inventory.ignoredZones property will be instantiated as a Zone resource
    { property: 'ignoredZones', resource: Zone },
    // inventory.toCheckZone property will be instantiated as a Zone resource
    { property: 'toCheckZone', resource: Zone },
    // inventory.lostZone property will be instantiated as a Zone resource
    { property: 'lostZone', resource: Zone },
  ]

  let defaultValues = () => ({
    inventoryZones: [],
    ignoredZones: [],
    upcs: [],
    $countersLoaded: false,
    counters: {
      expected: 0,
      detected: 0,
      unexpected: 0,
      detectedByUser: 0,
    },
  })

  let Inventory = TmrResource(
    'Inventory',
    {},
    referencedProperties,
    defaultValues
  )
  Object.assign(Inventory.prototype, {
    /**
     * Override default label property.
     *
     * @method Inventory#$getLabelProperty
     */
    $getLabelProperty: () => 'name',
    $getCounters,
  })

  return Inventory

  /**
   * Loads the counters on the current inventory.
   *
   * @method Inventory#$getCounters
   */
  function $getCounters() {
    if (!this.$countersLoaded) {
      this.$countersLoaded = true
      this.counters = this.counters ?? {}
      TmrApi.get('Inventory.counters', { id: this.id }).then(({ data }) =>
        Object.assign(this.counters, data)
      )
    }
    return this.counters
  }
}

export const factory = ['Inventory', InventoryFactory]
